import React, { useEffect, useState } from "react";
import { setBreadcrumbItems } from "../../store/actions";
import { connect } from "react-redux";
import Spinners from "components/Common/Spinner";
import * as url from "../../helpers/url_helper";
import { Row, Col, Card, CardBody, CardHeader, CardTitle } from "reactstrap";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const ViewCategory = (props) => {
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Event", link: "#" },
    { title: "Event Category Details", link: "#" },
  ];
  const [isLoading, setLoading] = useState(false);
  const [state, setState] = useState({});
  const { categoryid } = useParams();
  const { id } = useParams();
  useEffect(() => {
    getCategoryDetail();
    props.setBreadcrumbItems("View Event Category", breadcrumbItems);
  }, []);
  function getCategoryDetail(e) {
    setLoading(true);
    let urlPath = "eventcategory/getCategoryDetails/" + categoryid;
    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // body: Body,
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status) {
          var category = responseData.details;
          var data = {
            eventId: category.eventId,
            name: category.name || "--",
            price: category.price || "--",
            description: category.displayMsg || "--",
            status: category.status ? "Active" : "Inactive",
            allowRegister: category.allowRegister ? "Active" : "False",
          };

          setState(data);
        } else {
          toast.error(
            "Oops! \n\n Something went wrong, Please try again after sometime.",
          );
        }
      })
      .catch((error) => {})
      .finally((final) => {
        // this.recaptchaRef.current.reset();
        // return this.setState({ isInvitingUser: false })
      });
    setLoading(false);
  }
  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <div class="row col-12">
                  <div class="col-10">
                    <CardTitle className="h4 mb-0">
                      Event Category Details
                    </CardTitle>
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="card-body row">
                        <div className="row">
                          <table class="table table-bordered table-striped shadow-sm">
                            <tbody>
                              <tr>
                                <td>
                                  <label>Category Name:</label>{" "}
                                </td>
                                <td>
                                  <b>{state.name}</b>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <label>Price:</label>
                                </td>
                                <td>
                                  <b>{state.price}</b>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <label>Description:</label>
                                </td>
                                <td>
                                  <b>{state.description}</b>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <label>Status:</label>
                                </td>
                                <td>
                                  <b>{state.status}</b>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <label>Allow Register:</label>
                                </td>
                                <td>
                                  <b>{state.allowRegister}</b>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="d-flex">
                        <Link
                          to={`/Event/${id}/EventCategoryList`}
                          className="btn btn-primary"
                        >
                          <span
                            className="menu-text"
                            style={{ color: "white" }}
                          >
                            <i class="fa fa-arrow-left me-2"></i>Back to List
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};
export default connect(null, { setBreadcrumbItems })(ViewCategory);
